import { Typography } from "@cupcodev/ui";
import type { ReactNode } from "react";
import { parseInlineBold, parseSafeMarkdown } from "../shared/text/safe-markdown";

/** Renders owner help text. Only React text nodes: no HTML, links or images. */
const inline = (text: string): ReactNode[] =>
  parseInlineBold(text).map((part, index) => part.bold ? <strong key={index}>{part.text}</strong> : part.text);

export const SafeMarkdown = ({ text }: { text: string }) => (
  <div className="nave-md">
    {parseSafeMarkdown(text).map((block, index) => {
      if (block.kind === "heading") return <Typography key={index} as="h3" variant="title-sm">{inline(block.text)}</Typography>;
      if (block.kind === "paragraph") return <Typography key={index} as="p" variant="body-md">{inline(block.text)}</Typography>;
      const Tag = block.kind;
      return <Tag key={index}>{block.items.map((item, i) => <li key={i}>{inline(item)}</li>)}</Tag>;
    })}
  </div>
);
